import { darken } from "polished";
import styled from "styled-components";
import { Colors } from "../../ui";

const Frame = styled.div`
    position: relative;   
    display: inline-block;
    vertical-align: top;
    margin: 1rem;
    width: 20rem;
    height: 12rem;
`;

const Border = styled.div`
    position: relative;        
    height: 100%;
    display: flex; 
    flex-direction: column;
    align-items: flex-start;
    padding: 1rem 1.5rem;
    border: solid .125rem #eee;
    border-radius: .25rem;
    background: #FFFFFF;

    &:hover {
        cursor: pointer;
        box-shadow: 0 0 0 .125rem #eee;
    }

    &:active {
        cursor: pointer;
        border: solid .125rem ${darken(.05, '#eee')};
        box-shadow: 0 0 0 .125rem ${darken(.05, '#eee')};
    }
`;

const Icon = styled.div`
    display: flex;
    align-items: center;
    width: 4rem;
    height: 4rem;
`;

const Info = styled.div`
    width: 12rem;
`;

const Label = styled.div`
    font-size: 1.125rem;
    font-weight: 400;
    color: ${Colors.text};
    margin-top: .25em;
`;

const Desc = styled.div`
    font-size: .875rem;
    color: ${Colors.text};
    opacity: .7;
    margin-top: .25em;
`;

export const ManagementTile = Object.assign(Frame, {
    Border,
    Icon,
    Info,
    Label,
    Desc
});

export const ManagementTileMenu = styled.div`
    max-width: 66rem;
    padding-top: 2rem;
    margin: -1rem;
    flex: 1 1 auto;
`;